import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../lib/appStores'

/**
 * Identidad del sitio para buscadores y agentes de IA (spec 2026-10-04-agentes-ia-legibles,
 * F2). **Fuente única**: el plugin `siteShell` de `vite.config.ts` lo inyecta en el
 * `<head>` del HTML base, así que está en TODAS las respuestas aunque no se ejecute JS.
 * Las páginas no lo repiten en runtime (solo añaden su JSON-LD propio: eventos, FAQ, migas).
 *
 * Sin imports con alias ni `import.meta.env`: lo carga también `vite.config.ts` (Node).
 */
export const SITE_NAME = 'Match&Play'
export const SITE_DESCRIPTION =
  'Partidas presenciales de juegos de mesa con gente de tu ciudad, en España. Busca una mesa abierta, apúntate o crea la tuya. Gratis.'
export const INSTAGRAM_URL = 'https://www.instagram.com/matchandplay.es/'
export const CONTACT_EMAIL = 'matchplay.ops@gmail.com'
/** Imagen OG por defecto (también la usa `defaultMeta`). */
export const DEFAULT_OG_IMAGE = '/og/landing-es.png'

export function buildSiteIdentityJsonLd(appUrl: string) {
  const org = `${appUrl}/#organization`
  const app = (os: 'iOS' | 'Android', url: string) => ({
    '@type': 'MobileApplication',
    '@id': `${appUrl}/#app-${os.toLowerCase()}`,
    name: `${SITE_NAME} — juegos de mesa`,
    operatingSystem: os,
    applicationCategory: 'SocialNetworkingApplication',
    url,
    installUrl: url,
    inLanguage: ['es', 'en'],
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'EUR' },
    publisher: { '@id': org },
  })

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': org,
        name: SITE_NAME,
        alternateName: ['Matchplay', 'Match and Play', 'matchplay.es'],
        url: `${appUrl}/`,
        logo: { '@type': 'ImageObject', url: `${appUrl}/brand/logo-lockup.png` },
        description: SITE_DESCRIPTION,
        areaServed: { '@type': 'Country', name: 'España' },
        email: CONTACT_EMAIL,
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: CONTACT_EMAIL,
          url: `${appUrl}/contact`,
          availableLanguage: ['es', 'en'],
        },
        sameAs: [INSTAGRAM_URL, APP_STORE_URL, GOOGLE_PLAY_URL],
      },
      {
        '@type': 'WebSite',
        '@id': `${appUrl}/#website`,
        name: SITE_NAME,
        alternateName: 'Matchplay',
        url: `${appUrl}/`,
        description: SITE_DESCRIPTION,
        inLanguage: 'es-ES',
        publisher: { '@id': org },
      },
      app('iOS', APP_STORE_URL),
      app('Android', GOOGLE_PLAY_URL),
    ],
  }
}

/** JSON listo para un `<script type="application/ld+json">` (sin cierre de tag posible). */
export function serializeJsonLd(data: unknown): string {
  return JSON.stringify(data).replace(/</g, '\\u003c')
}
